<div class="global-header d-flex flex-column flex-column p-2 bg-white border-bottom rounded" style="height: 160px;padding: 0;margin: 0;">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="mb-0 me-2">Factures</h2>
        <p class="mb-0">Nombre total : {{ loading ? '...' : (stats?.total_factures?.nombre ?? '0') }}</p>
    </div>

    <div class="d-flex justify-content-between gap-3" *ngIf="error">
        <p class="text-danger mb-0">{{ error }}</p>
    </div>

    <div class="d-flex justify-content-between gap-3" *ngIf="!error">
        <!-- Bloc 1 : Factures payées -->
        <div class="d-flex align-items-center flex-grow-1" style="width: 100%; max-width: 200px;">
            <button type="button" class="facture-paye-button me-2">
                <a target="_blank" title="Factures payées">{{ loading ? '...' : (stats?.factures_payees?.nombre ?? 0) }}</a>
            </button>
            <div class="d-flex flex-column">
                <span class="number">{{ loading ? '...' : formatMontant(stats?.factures_payees?.montant_total) }}</span>
                <span class="phone-number">Factures payées</span>
            </div>
        </div>

        <!-- Bloc 2 : Factures à payer -->
        <div class="d-flex align-items-center flex-grow-1" style="width: 100%; max-width: 200px;">
            <button type="button" class="facture-a-paye-button me-2">
                <a target="_blank" title="Factures à payer">{{ loading ? '...' : (stats?.factures_non_payees?.nombre ?? 0) }}</a>
            </button>
            <div class="d-flex flex-column">
                <span class="number">{{ loading ? '...' : formatMontant(stats?.factures_non_payees?.montant_total) }}</span>
                <span class="phone-number">Facture à payer</span>
            </div>
        </div>

        <!-- Bloc 3 : Factures partiellement payées -->
        <div class="d-flex align-items-center" style="width: 100%; max-width: 222px;">
            <button type="button" class="facture-partiellement-paye-button me-2">
                <a target="_blank" title="Factures partiellement payées">{{ loading ? '...' : (stats?.factures_partiellement_payees?.nombre ?? 0) }}</a>
            </button>
            <div class="d-flex flex-column">
                <span class="number">{{ loading ? '...' : formatMontant(stats?.factures_partiellement_payees?.montant_total) }}</span>
                <span class="phone-number">Factures partiellement payées</span>
            </div>
        </div>
    </div>
</div>
